/**
 * WorkflowTabs.tsx - the open-workflow tab strip for the Workflows tab.
 *
 * Rendered inline in the MenuBar (like the graph tabs in View mode and the
 * dashboard tabs in Plot mode). Unlike graphs (pinned - every graph is always
 * open), workflow tabs are OPEN DOCUMENTS: opened from the picker modal,
 * closable with an X. The trailing `+` opens the workflow picker (search +
 * open + scaffold). Mirrors the `.graph-tab` styling so the strip reads as the
 * same tab chrome as the other views.
 */
import { Plus, X } from '@phosphor-icons/react';

interface WorkflowTabsProps {
  tabs: { id: string; name: string; error?: boolean }[];
  activeId: string | null;
  onSelect: (id: string) => void;
  onClose: (id: string) => void;
  /** Open the picker modal (the `+` tab). */
  onAdd: () => void;
}

export function WorkflowTabs({ tabs, activeId, onSelect, onClose, onAdd }: WorkflowTabsProps): JSX.Element {
  return (
    <div className="graph-tabs">
      {tabs.map((t) => (
        <div
          key={t.id}
          className={`graph-tab${activeId === t.id ? ' active' : ''}`}
          onClick={() => onSelect(t.id)}
          title={t.error ? `${t.name} (has errors)` : t.name}
        >
          <span className={`graph-tab-name${t.error ? ' wf-tab-error' : ''}`}>{t.name}</span>
          {activeId === t.id && (
            <span className="graph-tab-actions">
              <button
                type="button"
                className="btn-icon-mini"
                title="Close tab"
                onClick={(e) => {
                  e.stopPropagation();
                  onClose(t.id);
                }}
              >
                <X size={11} />
              </button>
            </span>
          )}
        </div>
      ))}
      <button
        type="button"
        className="graph-tab graph-tab-add"
        title="Open workflow…"
        onClick={onAdd}
      >
        <Plus size={14} />
      </button>
    </div>
  );
}
